import React from "react";

import Plug from "..";

const DataNotLoaded = ({ text = "данные" }) => {
  return <Plug text={`На выбранном интервале или при заданных фильтрах ${text} отсутствуют`} />;
};

export default DataNotLoaded;
